import React, { useState } from "react";
import { Box, AppBar, Toolbar, Typography, TextField, Button, Divider } from "@mui/material";
import { apiPost, ApiError } from "../api/client";

const EMAIL = "support@onlineretailerva.com";
const PHONE = "(757) 577-8544"; // text preferred
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function PublicContact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [company, setCompany] = useState(""); // honeypot
  const [status, setStatus] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async () => {
    if (sending) return;
    setStatus("");

    if (!name.trim() || !email.trim() || !message.trim()) {
      setStatus("Please fill name/email/message.");
      return;
    }
    if (!EMAIL_RE.test(email.trim())) {
      setStatus("Please enter a valid email address.");
      return;
    }

    setSending(true);
    try {
      await apiPost(
        "/api/public/contact",
        { name, email, message, company },
        { auth: false }
      );
      setStatus("Sent. Thanks!");
      setMessage("");
    } catch (e) {
      setStatus(e instanceof ApiError ? `Failed: ${e.message}` : "Failed to send. Try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#0b0f14", color: "#e7eef8" }}>
      <AppBar position="sticky" sx={{ bgcolor: "rgba(11,15,20,0.85)", backdropFilter: "blur(10px)" }}>
        <Toolbar sx={{ gap: 2 }}>
          <Typography
            variant="h6"
            sx={{ fontWeight: 800, cursor: "pointer" }}
            onClick={() => (window.location.href = "/")}
          >
            OnlineRetailerVA
          </Typography>
          <Box sx={{ flex: 1 }} />
          <Button
            variant="outlined"
            sx={{ borderColor: "rgba(255,255,255,0.18)", color: "#e7eef8" }}
            onClick={() => (window.location.href = "/")}
          >
            Back to catalog
          </Button>
        </Toolbar>
      </AppBar>

      <Box
        sx={{
          maxWidth: 780,
          mx: "auto",
          p: 2,
          mt: 2,
          borderRadius: 2,
          bgcolor: "rgba(255,255,255,0.04)",
          border: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 800, mb: 1 }}>
          Contact
        </Typography>

        <Typography sx={{ opacity: 0.85, mb: 2 }}>
          Local pickups are <b>by appointment only</b>. Please <b>text</b> to arrange a pickup time.
        </Typography>

        <Box sx={{ display: "grid", gap: 0.5, mb: 2 }}>
          <Typography sx={{ opacity: 0.9 }}>
            <b>Email:</b> {EMAIL}
          </Typography>
          <Typography sx={{ opacity: 0.9 }}>
            <b>Phone/Text:</b> {PHONE}
          </Typography>
        </Box>

        <Divider sx={{ borderColor: "rgba(255,255,255,0.10)", mb: 2 }} />

        <Typography sx={{ opacity: 0.8, mb: 1 }}>
          Or send a message here:
        </Typography>

        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 2 }}>
          <TextField
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            size="small"
            sx={{
              "& .MuiInputBase-root": { bgcolor: "rgba(255,255,255,0.06)", color: "#e7eef8", borderRadius: 2 },
              "& fieldset": { borderColor: "rgba(255,255,255,0.12)" },
              "& label": { color: "rgba(231,238,248,0.75)" },
            }}
          />
          <TextField
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            size="small"
            sx={{
              "& .MuiInputBase-root": { bgcolor: "rgba(255,255,255,0.06)", color: "#e7eef8", borderRadius: 2 },
              "& fieldset": { borderColor: "rgba(255,255,255,0.12)" },
              "& label": { color: "rgba(231,238,248,0.75)" },
            }}
          />
        </Box>

        <Box sx={{ mt: 2 }}>
          <TextField
            label="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            multiline
            minRows={6}
            fullWidth
            sx={{
              "& .MuiInputBase-root": { bgcolor: "rgba(255,255,255,0.06)", color: "#e7eef8", borderRadius: 2 },
              "& fieldset": { borderColor: "rgba(255,255,255,0.12)" },
              "& label": { color: "rgba(231,238,248,0.75)" },
            }}
          />
        </Box>

        {/* Honeypot (hidden) */}
        <input value={company} onChange={(e) => setCompany(e.target.value)} style={{ display: "none" }} />

        <Box sx={{ mt: 2, display: "flex", gap: 2, alignItems: "center" }}>
          <Button
            variant="contained"
            onClick={submit}
            disabled={sending}
            sx={{ bgcolor: "rgba(255,255,255,0.14)", color: "#e7eef8" }}
          >
            {sending ? "Sending…" : "Send"}
          </Button>
          <Typography sx={{ opacity: 0.75, fontSize: 13 }}>{status}</Typography>
        </Box>
      </Box>
    </Box>
  );
}